import React, {useEffect, useState} from "react";
import {
    HTMLTable,
    NonIdealState,
    SectionCard,
} from "@blueprintjs/core";
import myAxios from "../myAxios";
import {loadingState} from "../recoil/loadingState";
import {useSetRecoilState} from 'recoil';
import {headCell} from "../style/TableStyle";
import moment from "moment";
import 'moment/locale/ko';
import Pageable from "../element/Pageable";
import {useNavigate, useSearchParams} from "react-router-dom";
import {commaRegex, phoneNumberRegex} from "../util/RegexUtil";
import {evWorkState} from "../static/EvWorkState";
import {confirmState} from "../recoil/confirmState";
import {alertState} from "../recoil/alertState";

export default function SatOrderList({findReq, pageable, setPageable, res, setRes, reload, setReload}) {

    let navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const setLoading = useSetRecoilState(loadingState);
    const setConfirm = useSetRecoilState(confirmState);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        setReload(true);
    }, [pageable]);

    useEffect(() => {
        if (!reload) return;
        setReload(false);

        searchParams.set('body', JSON.stringify(findReq))
        searchParams.set('pageable', JSON.stringify(pageable))
        setSearchParams(searchParams)

        setLoading({active: true, text: '데이터를 불러오는 중입니다...'})
        myAxios.post(`/sat/order/find?size=${pageable.size}&page=${pageable.page}`, findReq)
            .then((res) => setRes(res.data))
            .finally(() => setLoading({active: false}))
    }, [reload]);

    return (<>
        <SectionCard style={{overflow: 'auto'}}>
            {res?.content?.length ?
                <HTMLTable className={'table-info'} compact style={{width: '100%'}}>
                    <tr>
                        <th style={headCell}>No.</th>
                        <th style={headCell}>BRAND</th>
                        <th style={headCell}>품목명</th>
                        <th style={headCell}>품목코드</th>
                        <th style={headCell}>발주량</th>
                        <th style={headCell}>발주일자</th>
                        <th style={headCell}>등록자</th>
                    </tr>
                    {res?.content?.map((satOrder) => {
                        return (
                            <tr className={'order-tr'} onClick={() => {
                                setConfirm({
                                    active: true, text: '발주을 삭제하시겠습니까?', onConfirm: () => {
                                        setLoading({active: 'true'})
                                        myAxios.delete(`/sat/order/${satOrder.id}`).then((res) => {
                                            setAlert({active: true, text: '삭제되었습니다.'})
                                            setReload(true)
                                        }).finally(() => setLoading({active: false}));
                                    }
                                })
                            }}>
                                <td>{satOrder.id}</td>
                                <td>{satOrder.brand?.name}</td>
                                <td>{satOrder.item?.name}</td>
                                <td>{satOrder.item?.code}</td>
                                <td>{satOrder.quantity}</td>
                                <td>{satOrder.orderDate}</td>
                                <td>{satOrder.user.name}</td>
                            </tr>
                        );
                    })}
                </HTMLTable>
                :
                <NonIdealState
                    icon={"search"} title={'검색결과가 없습니다'} style={{padding: '20px'}}
                    description={<>검색조건을 다시 한번 확인해주세요.<br/>데이터가 존재하지 않거나 검색조건이 잘못되었을 수 있습니다.</>}
                />
            }
        </SectionCard>

        <SectionCard style={{padding: 0}}>
            <Pageable pageable={pageable} setPageable={setPageable} totalPages={res.totalPages}/>
        </SectionCard>
    </>);
}